
import { supabase } from "@/integrations/supabase/client";

export interface RouteItem {
  id: string;
  title: string;
  path: string;
  componentName: string;
  icon?: string;
  section?: string;
  displayOrder?: number;
  isRouteEnabled: boolean;
  requiresAdmin: boolean;
}

/**
 * Fetches all available routes from the database
 */
export const fetchAllRoutes = async (): Promise<RouteItem[]> => {
  try {
    const { data, error } = await supabase.rpc('get_all_routes');
    
    if (error) {
      console.error("Error fetching routes:", error);
      return [];
    }
    
    return data.map((route: any) => ({
      id: route.id,
      title: route.title,
      path: route.path,
      componentName: route.component_name,
      icon: route.icon,
      section: route.section,
      displayOrder: route.display_order,
      isRouteEnabled: route.is_route_enabled,
      requiresAdmin: route.requires_admin
    }));
  } catch (err) {
    console.error("Exception in fetchAllRoutes:", err);
    return [];
  }
};

/**
 * Checks if a user has access to a specific route
 */
export const checkRouteAccess = async (userId: string, path: string): Promise<boolean> => {
  try {
    const { data, error } = await supabase.rpc('user_can_access_menu_item', {
      p_user_id: userId,
      p_menu_path: path
    });
    
    if (error) {
      console.error("Error checking route access:", error);
      return false;
    }
    
    return !!data;
  } catch (err) {
    console.error("Exception in checkRouteAccess:", err);
    return false;
  }
};

/**
 * Gets accessible menu items for the current user
 */
export const fetchAccessibleMenuItems = async (userId?: string): Promise<RouteItem[]> => {
  try {
    const params = userId ? { p_user_id: userId } : {};
    const { data, error } = await supabase.rpc('get_accessible_menu_items', params);
    
    if (error) {
      console.error("Error fetching accessible menu items:", error);
      return [];
    }
    
    return data.map((item: any) => ({
      id: item.id,
      title: item.title,
      path: item.path,
      componentName: item.component_name,
      icon: item.icon,
      section: item.section,
      displayOrder: item.display_order,
      isRouteEnabled: item.is_route_enabled,
      requiresAdmin: false // This isn't returned by the function but can be inferred elsewhere
    }));
  } catch (err) {
    console.error("Exception in fetchAccessibleMenuItems:", err);
    return [];
  }
};
